import React from 'react'
import "../Styles/Bookmarked.css"
import Rajasthan from "../Images/rajasthan_pic.png"
import Bookmarked_img from "../Images/bookmarked.png"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBookmark } from "@fortawesome/free-solid-svg-icons"

function Bookmarked() {
  return (
    <div>


      <div class="tripCard_wrapper">
        <div class="tripCard_image">
          <img src={Rajasthan} alt="Rajasthan Tour" />
        </div>
        <div class="tripCard_content">
          <h2 class="tripCard_title">Rajasthan Tour</h2>
          <p class="tripCard_date">21st Jun - 15th Aug</p>
          <div class="tripCard_buttons">
            <button class="tripCard_btnDetails">View details</button>
            <div style={{ display: "flex", alignItems: "center" }}>
              {/* <img className='bookmarked_icon' src={Bookmarked_img} alt="bookmarked icon" height="20px"/> */}
              <FontAwesomeIcon icon={faBookmark} />
            </div>

            {/* <button class="tripCard_btnCancel">Cancel</button> */}
          </div>

        </div>

      </div>



    </div>
  )
}

export default Bookmarked